var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sms-channel-widget" },
    [
      _c(
        "md-button",
        {
          ref: "buttonRef",
          staticClass: "actionButtonBreadcrumb m-0 wp-btn sms-status-button",
          staticStyle: { "min-width": "20px", "max-width": "25px" },
          on: {
            mouseenter: function ($event) {
              _vm.smsIconHovered = true
            },
            mouseleave: function ($event) {
              _vm.smsIconHovered = false
            },
            click: _vm.toggleDropdown,
          },
        },
        [
          _c("SMSIcon", {
            staticClass: "sms-icon",
            attrs: {
              color:
                _vm.smsIconHovered || _vm.isDropdownVisible
                  ? "green"
                  : "#3A3F48",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c(
            "div",
            {
              staticClass: "custom-dropdown",
              class: { "dropdown-ready": _vm.dropdownReady },
              style: _vm.dropdownStyle,
            },
            [
              _c(
                "div",
                { staticClass: "dropdown-content" },
                _vm._l(_vm.channels, function (channel, index) {
                  return _vm.channels.length > 0
                    ? _c("ChannelStatusItem", {
                        key: channel._id,
                        attrs: {
                          channel: channel,
                          whatsappModal: false,
                          "sms-modal": true,
                        },
                        on: { close: _vm.closeDropdown },
                      })
                    : _vm._e()
                }),
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isDropdownVisible
        ? _c("div", {
            staticClass: "dropdown-backdrop",
            on: { click: _vm.closeDropdown },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }